import apiService from './apiService';

const PARTNERS_BASE = `${process.env.REACT_APP_API_URL || ''}/api/response-partners`;
const RULES_BASE = `${process.env.REACT_APP_API_URL || ''}/api/response-partner-routing-rules`;

const buildQuery = (params = {}) => {
  const filtered = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '');
  if (filtered.length === 0) return '';
  const search = new URLSearchParams();
  for (const [k, v] of filtered) search.set(k, String(v));
  return `?${search.toString()}`;
};

export const getResponsePartnersService = async (filters = {}) => {
  try {
    const response = await apiService.get(`${PARTNERS_BASE}${buildQuery(filters)}`);
    return response.data;
  } catch (error) {
    console.error('Error listing response partners:', error);
    throw error;
  }
};

export const getResponsePartnerService = async (partnerId) => {
  try {
    const response = await apiService.get(`${PARTNERS_BASE}/${partnerId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting response partner:', error);
    throw error;
  }
};

export const createResponsePartnerService = async (payload) => {
  try {
    const response = await apiService.post(`${PARTNERS_BASE}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating response partner:', error);
    throw error;
  }
};

export const updateResponsePartnerService = async (partnerId, payload) => {
  try {
    const response = await apiService.patch(`${PARTNERS_BASE}/${partnerId}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating response partner:', error);
    throw error;
  }
};

export const deleteResponsePartnerService = async (partnerId) => {
  try {
    const response = await apiService.delete(`${PARTNERS_BASE}/${partnerId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting response partner:', error);
    throw error;
  }
};

export const getRoutingRulesService = async (filters = {}) => {
  try {
    const response = await apiService.get(`${RULES_BASE}${buildQuery(filters)}`);
    return response.data;
  } catch (error) {
    console.error('Error listing routing rules:', error);
    throw error;
  }
};

export const getRoutingRuleService = async (ruleId) => {
  try {
    const response = await apiService.get(`${RULES_BASE}/${ruleId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting routing rule:', error);
    throw error;
  }
};

export const createRoutingRuleService = async (payload) => {
  try {
    const response = await apiService.post(`${RULES_BASE}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating routing rule:', error);
    throw error;
  }
};

export const updateRoutingRuleService = async (ruleId, payload) => {
  try {
    const response = await apiService.patch(`${RULES_BASE}/${ruleId}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating routing rule:', error);
    throw error;
  }
};

export const deleteRoutingRuleService = async (ruleId) => {
  try {
    const response = await apiService.delete(`${RULES_BASE}/${ruleId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting routing rule:', error);
    throw error;
  }
};

const MAINTENANCE_TICKETS_BASE = `${process.env.REACT_APP_API_URL || ''}/api/maintenance-tickets`;

export const sendResponsePartnerDispatchService = async (maintenanceTicketId, payload = {}) => {
  try {
    const response = await apiService.post(
      `${MAINTENANCE_TICKETS_BASE}/${maintenanceTicketId}/response-partner-dispatch`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error sending response partner dispatch:', error);
    throw error;
  }
};
